import React from 'react';

import EditorLinkIcon from '@atlaskit/icon/glyph/editor/link';
import { DEPENDENCY_SETTINGS } from '@atlassian/jira-portfolio-3-portfolio/src/common/view/constant';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from './styles.module.css';
import type { Props } from './types';

export default function DependencyLegendIcon({ withWarning, dependencyDisplay }: Props) {
	return (
		<>
			{dependencyDisplay === DEPENDENCY_SETTINGS.LINES && (
				<span
					// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
					className={`${styles.dependencyLine} ${
						withWarning ? styles.dependencyLineWithWarning : ''
					}`}
				/>
			)}
			<div
				// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
				className={`${styles.harmonisedDependency} ${
					withWarning ? styles.harmonisedDependencyWithWarning : ''
				}`}
			>
				{dependencyDisplay !== DEPENDENCY_SETTINGS.COUNT ? (
					<EditorLinkIcon label="" size="small" />
				) : (
					'1'
				)}
			</div>
		</>
	);
}
